import api from './api';
import { SkoolCommunityInfo } from './accountService';

export const trainingService = {
  async getSkoolCommunityInfo(): Promise<SkoolCommunityInfo> {
    const response = await api.get<SkoolCommunityInfo>('/training');
    return response.data;
  },
};
